<template>
    <el-row style="display: flex; height: 100%;" align="middle" :loading="pageLoading">
        <el-col :span="10" style="border: 1px solid #ccc; position: relative;">
            <img v-if="resType === 2" :src="link" alt="" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-width: 90%; max-height: 90%;">
            <video v-else :src="link" controls="controls" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-width: 90%; max-height: 90%;"></video>
        </el-col>
        <el-col :span="14" style="border: 1px solid #ccc; padding: 10px; overflow-y: scroll;">
            <div v-if="auditStatus === 0 || auditStatus === 1">
                <div class="loader loader--spinningDisc"></div>
                <div style="font-size: 27px;">
                    <span v-if="resultCheckTimes < 10 || true">审核中......</span>
                    <span v-else>审核进行中，等待时间较长，可继续等待，或稍后去管理中心查看审核记录</span>
                </div>
            </div>
            <div v-else-if="auditStatus === 2" style="margin-top: 150px; font-size: 27px; color: limegreen;">
                审核通过，资源正常
            </div>
            <el-tabs v-if="auditStatus === 3" type="border-card" class="audit-result">
                <el-tab-pane v-for="typeItem in errorList" :label="typeItem.type" :key="typeItem.type">
                    <!-- 关键词、文本、审核物料、缩略图 -->
                    <el-table border :data="typeItem.data">
                        <template v-if="typeItem.type === '错别字'">
                            <el-table-column prop="word" label="错别字" width="120"></el-table-column>
                            <el-table-column prop="trueword" label="建议修改" width="120"></el-table-column>
                            <el-table-column prop="text" label="所在文本"></el-table-column>
                        </template>
                        <template v-else-if="typeItem.type === '敏感词'">
                            <el-table-column prop="word" label="敏感词" width="120"></el-table-column>
                            <el-table-column prop="senstype" label="敏感词类型" width="120"></el-table-column>
                            <el-table-column prop="text" label="所在文本"></el-table-column>
                        </template>
                        <template v-else-if="typeItem.type === '禁用词'">
                            <el-table-column prop="word" label="禁用词" width="120"></el-table-column>
                            <el-table-column prop="text" label="所在文本"></el-table-column>
                        </template>
                        <template v-else-if="typeItem.type === '疑似错别字'">
                            <el-table-column prop="word" label="疑似错别字" width="120"></el-table-column>
                            <el-table-column prop="trueword" label="建议修改" width="120"></el-table-column>
                            <el-table-column prop="text" label="所在文本"></el-table-column>
                        </template>
                        <template v-else>
                            <el-table-column prop="errType" label="问题类型" width="120"></el-table-column>
                            <el-table-column prop="keyword" label="关键词" width="120"></el-table-column>
                            <el-table-column prop="text" label="文本"></el-table-column>
                            <el-table-column prop="timeInSeconds" label="所在位置" width="180" align="center" v-if="resType === 3 || resType === 4">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.multi === true">{{ scope.row.timeInSeconds }} - {{ scope.row.endSeconds }}</span>
                                    <span v-else>{{ scope.row.timeInSeconds }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="thumbnail" label="缩略图" width="200" align="center" v-if="resType !== 4">
                                <template slot-scope="scope">
                                    <img class="err-thumbnail" :src="scope.row.thumbnail" alt="" height="100px" @click="zoomImg(scope.row.thumbnail)">
                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <el-dialog :visible.sync="zoomImgDlg.show" width="700px" :append-to-body="true">
                <div>
                    <img :src="zoomImgDlg.image" alt="" style="max-width: 90%; max-height: 90%;">
                </div>
                <div slot="footer"></div>
            </el-dialog>
        </el-col>
    </el-row>
</template>

<script>
export default {
    data () {
        return {
            pageLoading: false,
            resType: 2,     // 2-图片 3-视频
            link: '',
            auditStatus: 0,
            resultCheckTimes: 0,
            errorList: [],
            zoomImgDlg: {
                show: false,
                image: ''
            }
        }
    },
    methods: {
        zoomImg(imgUrl) {
            this.zoomImgDlg.show = true
            this.zoomImgDlg.image = imgUrl
        },
        setPageLoading (val) { this.pageLoading = val },
        setResLink (resType, link) { this.resType = resType; this.link = link },
        setAuditResult (errlist) {
            console.log('设置审核结果：', this.resType, errlist)
            this.errorList = []
            this.auditStatus = errlist.length > 0 ? 3 : 2
            this.errorList = this.getFormatResult(errlist, this.resType === 3)
        },
        getFormatResult (resultList, isVideo) {
            var fmResults = []
            for (var errIdx in resultList) {
                var errItem = resultList[errIdx]
                console.log('处理结果:', errIdx, errItem)
                var typeExist = false;

                if (errItem.scenes === '文本') {
                    for (var i = 0; i < fmResults.length; i++) {
                        if (fmResults[i].type === errItem.subType) {
                            fmResults[i].data.push({
                                word: errItem.word,
                                trueword: errItem.trueword ? errItem.trueword : '',
                                text: errItem.text,
                                senstype: errItem.senstype ? errItem.senstype : ''
                            })
                            typeExist = true; break
                        }
                    }
                    if (!typeExist) {
                        fmResults.push({ type: errItem.subType, data: [] })
                        fmResults[fmResults.length - 1].data.push({
                            word: errItem.word,
                            trueword: errItem.trueword ? errItem.trueword : '',
                            text: errItem.text,
                            senstype: errItem.senstype ? errItem.senstype : ''
                        })
                    }
                } else {
                    for (var i = 0; i < fmResults.length; i++) {
                        if (fmResults[i].type === errItem.scenes) {    // 类型已存在，直接在类型下写入错误结果
                            typeExist = true
                            var typeLastErrIdx = fmResults[i].data.length - 1
                            var typeLastErr = fmResults[i].data[typeLastErrIdx]
                            if (isVideo && errItem.subType === typeLastErr.errType && errItem.extra === typeLastErr.keyword && errItem.text === typeLastErr.text) {
                                if (typeLastErr.endSeconds !== errItem.timeInSeconds) {
                                    fmResults[i].data[typeLastErrIdx].multi = true
                                    fmResults[i].data[typeLastErrIdx].endSeconds = errItem.timeInSeconds
                                }
                            } else {
                                fmResults[i].data.push({
                                    errType: errItem.subType,
                                    keyword: errItem.extra,
                                    text: errItem.text,
                                    thumbnail: errItem.thumbnail,
                                    timeInSeconds: ((isVideo || this.resType === 4) ? errItem.timeInSeconds : 0),
                                    endSeconds: ((isVideo || this.resType === 4) ? errItem.timeInSeconds : 0),
                                    multi: false
                                })
                            }
                            break
                        }
                    }
                    if (!typeExist) {
                        fmResults.push({ type: errItem.scenes, data: [] })
                        fmResults[fmResults.length - 1].data.push({
                            errType: errItem.subType,
                            keyword: errItem.extra,
                            text: errItem.text,
                            thumbnail: errItem.thumbnail,
                            timeInSeconds: ((isVideo || this.resType === 4) ? errItem.timeInSeconds : 0),
                            endSeconds: ((isVideo || this.resType === 4) ? errItem.timeInSeconds : 0),
                            multi: false
                        })
                    }
                }
            }
            return fmResults
        }
    }
}
</script>

<style>
.audit-result > .el-tabs--border-card > .el-tabs__content {
    position: absolute;
    top: 125px;
    bottom: 0px;
    left: 30px;
    right: 30px;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/MediaAuditResult.vue